import script from "./image-item.vue?vue&type=script&setup=true&lang=js"
export * from "./image-item.vue?vue&type=script&setup=true&lang=js"

import "./image-item.vue?vue&type=style&index=0&id=5d791a3c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d791a3c"]])

export default __exports__